"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlatSaleCallbackBannerContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _tracking = require("../../utils/tracking");
var _actionAfterViewedComponent = require("@cian/action-after-viewed-component");
var _useConsultingRequest2 = require("../../hooks/useConsultingRequest");
var _uiKit = require("@cian/ui-kit");
var _FlatSaleCallbackBannerDesktop = require("../../components/FlatSaleCallbackBannerDesktop");
var _FlatSaleCallbackBannerSuccess = require("../../components/FlatSaleCallbackBannerDesktop/FlatSaleCallbackBannerSuccess");
var _FlatSaleCallbackBannerSuccess2 = require("../../components/FlatSaleCallbackBannerMobile/FlatSaleCallbackBannerSuccess");
var _FlatSaleCallbackBannerMobile = require("../../components/FlatSaleCallbackBannerMobile");
var _FlatSaleCallbackBannerSuccess3 = require("../../components/FlatSaleCallbackBannerTablet/FlatSaleCallbackBannerSuccess");
var _FlatSaleCallbackBannerTablet = require("../../components/FlatSaleCallbackBannerTablet");
const _excluded = ["success"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FlatSaleCallbackBannerContainer = _ref => {
  let {
    personalAgreementLink,
    defaultPhoneNumber,
    regionId,
    placeType,
    gaLabel,
    userId
  } = _ref;
  const _useConsultingRequest = (0, _useConsultingRequest2.useConsultingRequest)({
      defaultPhoneNumber,
      regionId,
      placeType,
      gaLabel,
      cianFlatSaleRefocus: true,
      userId
    }),
    {
      success
    } = _useConsultingRequest,
    bannerProps = (0, _objectWithoutProperties2.default)(_useConsultingRequest, _excluded);
  if (success) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      desktop: true
    }, /*#__PURE__*/React.createElement(_FlatSaleCallbackBannerSuccess.FlatSaleCallbackBannerDesktopSuccess, {
      placeType: placeType
    })), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      tablet: true
    }, /*#__PURE__*/React.createElement(_FlatSaleCallbackBannerSuccess3.FlatSaleCallbackBannerTabletSuccess, {
      placeType: placeType
    })), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      phone: true
    }, /*#__PURE__*/React.createElement(_FlatSaleCallbackBannerSuccess2.FlatSaleCallbackBanneMobileSuccess, null)));
  }
  return /*#__PURE__*/React.createElement(_actionAfterViewedComponent.ActionAfterViewObserver, {
    callback: _tracking.trackCallbackBannerShow,
    percentVisible: 1,
    triggerOnce: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true
  }, /*#__PURE__*/React.createElement(_FlatSaleCallbackBannerDesktop.FlatSaleCallbackBannerDesktop, (0, _extends2.default)({}, bannerProps, {
    personalAgreementLink: personalAgreementLink,
    placeType: placeType
  }))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    tablet: true
  }, /*#__PURE__*/React.createElement(_FlatSaleCallbackBannerTablet.FlatSaleCallbackBannerTablet, (0, _extends2.default)({}, bannerProps, {
    personalAgreementLink: personalAgreementLink,
    placeType: placeType
  }))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true
  }, /*#__PURE__*/React.createElement(_FlatSaleCallbackBannerMobile.FlatSaleCallbackBannerMobile, (0, _extends2.default)({}, bannerProps, {
    personalAgreementLink: personalAgreementLink,
    placeType: placeType
  })))));
};
exports.FlatSaleCallbackBannerContainer = FlatSaleCallbackBannerContainer;